import { gql } from '@apollo/client';

export const UPLOAD = gql`
  mutation uploadStock($file: Upload!) {
    uploadStock(file: $file) {
      success
    }
  }
`;
